// test1120
(1120 && 0);
